import { render, staticRenderFns } from "./cartonManagement.vue?vue&type=template&id=3cfb901f&"
import script from "./cartonManagement.vue?vue&type=script&lang=js&"
export * from "./cartonManagement.vue?vue&type=script&lang=js&"
import style0 from "./cartonManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports